/**
 *
 * @returns
 */

import { useEffect, useState } from 'react';
import ClinicalInformation from '../../emr/components/clinical-information/clinical-information';
import VisitInfo from '../../emr/components/visit-info/visit-info';
import { Form, Typography, Input, message, Col, Row, Select, Skeleton,Modal } from 'antd';
import { Location, useTranslation, DatePicker,Card, Button} from 'soxo-bootstrap-core';
import { Questionaire } from '../questionaire/questionaire';
import './followup-entry-screen.scss';
import DoctorNotesLabResult from '../lab-result/lab-result-doctor-notes';
import RadiologyResult from '../radiology-result/radiology-result';
import { Bills, ServiceResultMaster } from '../../../models';

import { AimOutlined } from '@ant-design/icons';


import moment from 'moment-timezone';
import MedicalReports from '../../common/components/medical-reports/medical-reports';

const { Option } = Select;

const { Title } = Typography;

const { TextArea } = Input;

const formItemLayout = {
    layout: 'vertical',
};

export default function FollowUpEntryScreen({templateCode,aiReportEditDisable, ...props }) {
    var urlParams = Location.search();
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation(); // To Translate to another language
    const [guest, setGuest] = useState({});
    const [loading, setLoading] = useState(true);
    const [referenceId, setReferenceId] = useState(urlParams.bill_id);
    const [response, setResponse] = useState({});
    const [data, setData] = useState({});
    const [status, setStatus] = useState();
    const [btnLoading, setBtnLoading] = useState(false);

    let [visible, setVisible] = useState(false); // State to control the visibility of the Modal
    

    useEffect(() => {
        loadFollowUpstatus();
        loadFollowUpDetails(referenceId);
    }, []);


    

    /**
     * Loads follow-up details and updates the form fields.
     *
     * @async
     * @returns {Promise<void>} - Updates form fields and sets response data.
     */
    async function loadFollowUpDetails(referenceId) {
        setLoading(true);
        // Fetch follow-up details using the referenceId
        let body ={
            bill_id: referenceId,
            rad_script: props.coreScriptId, 
            opno:urlParams.opno,
            lab_script:props.labCoreScript
        }
        let response = await Bills.followUpDetails(body);
        // Set form fields with the retrieved follow-up data
        form.setFieldsValue({
            followup_status: response.data?.followup_status,
            physician_notes: response.data?.physician_notes?.trim(),
            next_follow_date: response.data.next_follow_date ? moment(response.data.next_follow_date) : null,
            follow_up_remarks: response.data.follwup_remark,
        });
        setResponse(response.data);
        setLoading(false);
        // Indicate that loading has finished
    }

    /**
     * Loads follow-up status options from the service result master.
     *
      - Fetches follow-up status data and updates state.
     */
    async function loadFollowUpstatus() {
        let status = await ServiceResultMaster.getServiceResultMaster(props.followUpStatusCategory);
        setStatus(status.data);
    }
    /**
     * Submits follow-up entry by preparing form data and sending a request.
     *
     * @async
     * @function submitFollowUpEntry
     * @returns {Promise<void>} - Sends follow-up data and displays success/error message.
     */
    async function submitFollowUpEntry() {
        // Retrieve form input values
        setBtnLoading(true);
        let forminputValues = form.getFieldValue();
        // Prepare follow-up data payload by mapping existing radiology follow-up data
        let payload = await data.rad_followup_data?.map((ele) => {
            return (ele = {
                rad_followup_status: ele.rad_followup_status,
                rad_followup_remark: ele.rad_followup_remarks,
                itemptr: ele.itemptr,
                accession_no: ele.accession_no,
                modalityptr: ele.modalityptr,
                detrefid: ele.detrefid,
                consultant_doctor: ele.consultant_doctor,
                consultant_hospital: ele.consultant_hospital,
                comments: ele.comments,
            });
        });
        // Construct the request body
        let formBody = {
            radiology_result: payload || [],
            opno: urlParams.opno,
            bill_id: urlParams.bill_id,
            // next_follow_date:forminputValues.next_follow_date,
            followup_status: forminputValues.followup_status,
            reference_type: props.referenceType,
            // lab_followup_status: data?.lab?.lab_followup_status,
            // lab_followup_remark: data?.lab?.lab_followup_remarks,
            follwup_remark: forminputValues.follow_up_remarks,
            questionaire: data && data.questionaire ? Object.values(data.questionaire) : null,
            lab_result: [],
        };
        if (data?.lab_followup_data?.length > 0) {
            formBody = {
                ...formBody,
                lab_result: data.lab_followup_data,
            };
        }

        if (forminputValues.next_follow_date) {
            formBody = {
                ...formBody,
                next_followup: moment(forminputValues.next_follow_date).format('YYYY-MM-DD'),
            };
        }

        let response = await Bills.createFollowupData(formBody);
        // Handle the API response
        if (response.success) {
            message.success(response.message);
            loadFollowUpDetails(urlParams.bill_id);
        } else {
            message.error(response.message);
        }
        setBtnLoading(false);
    }
    /**
     * Disables past dates in the date picker.
     *
     * @function disabledDate
     * @param {moment.Moment} current - The current date being evaluated.
     * @returns {boolean} - Returns true if the date should be disabled, otherwise false.
     */
    const disabledDate = (current) => {
        // Can not select days before today and today
        return moment().add(-1, 'days') >= current;
    };
    /**
     * Handles the status change of a follow-up record.
     *
     * @function handleStatusChange
     * @param {Object} record - The record that needs to be updated.
     * @param {string} key - The key representing the property to be updated.
     */
    const handleStatusChange = (record, key, mode) => {
        let existingArray = mode === 'rad' ? data?.rad_followup_data || [] : data?.lab_followup_data || [];

        // Check if the record already exists
        const exists = existingArray.some((item) => (mode === 'rad' ? item.itemptr === record.itemptr : item.group === record.group));

        // Update or add the record
        let updatedArray = exists
            ? existingArray.map((item) =>
                  (mode === 'rad' ? item.itemptr === record.itemptr : item.group === record.group) ? { ...item, [key]: record[key] } : item
              )
            : [...existingArray, record];

        // Update the state
        setData({
            ...data,
            [mode === 'rad' ? 'rad_followup_data' : 'lab_followup_data']: updatedArray,
        });
    };

    return (
        
        <div className="followup">
            <Card>
            <div className="followup-entry-screen">
                {/* {loading ? (
                    <div className="">
                        <Skeleton/>
                    </div>
                ) : ( */}
                <>
                    {/** Page Header section start */}
                    <div className="follow-screen-page-header">
                        {/** Page right section start */}

                        <div className="right-page-section">
                            {/** Guest information-section start */}
                            <div className="guest-information-section">
                                <VisitInfo
                                    mode={'opreg'}
                                    // reference_number={'NURA8604'}
                                    reference_number={urlParams.opno ? urlParams.opno : props.OPNo}
                                    onReceiveGuestDetails={(patient) => {
                                        setGuest(patient);
                                    }}
                                    startLoading={() => setLoading(true)}
                                    enableBillnumber={props.enableBillnumber}
                                    disableFields={true}
                                    disableGuestChange={props.disableGuestChange}
                                    callback={async (values, bills) => {
                                        setReferenceId(values);
                                        let record = bills.filter((ele) => ele.opb_id === values)[0];

                                        let redirectLink;

                                        if (props.path) {
                                            redirectLink = props.path;
                                        }

                                        redirectLink = redirectLink.replace(':id', record.opb_id);

                                        if (urlParams.bill_id !== record.opb_id) {
                                            // Location.navigate({
                                            //     url: `${redirectLink}?bill_id=${record.opb_id}&opno=${record.opb_opno}`,
                                            // });
                                            // loadFollowUpDetails()
                                            Location.navigate({
                                                url: `${redirectLink}?bill_id=${record.opb_id}&opno=${record.opb_opno}`,
                                                replace: true, // Ensures it replaces the URL in history
                                            });

                                            await loadFollowUpDetails(record.opb_id);
                                        }
                                    }}
                                ></VisitInfo>
                            </div>
                            {/** Guest information-section End */}

                            {/** Clinical information-section start */}
                            <div className="clinical-information-section">
                                {!loading ? (
                                    <ClinicalInformation
                                        mode={props.mode}
                                        // refrence_number={'NURA8604'}
                                        reference_number={urlParams.opno ? urlParams.opno : props.OPNo}
                                        // refrence_id={'39786'}
                                        refrence_id={urlParams.bill_id ? urlParams.bill_id : props.opb_id}
                                        readOnlyMode={props.readOnlyMode}
                                        visit_id={referenceId}
                                    ></ClinicalInformation>
                                ) : null}
                            </div>
                            {/** Clinical information-section end */}
                        </div>


                        {/* /**
                        * Physician Notes Section
                        *
                        * Renders a "Physician Notes" label with a right-aligned
                        * "View AI Physician Note" button. Clicking the button opens
                        * a modal with the MedicalReports component. A read-only
                        * TextArea displays the notes below.
                        */ }

                       <div className="physician_notes-section">
                            <Form {...formItemLayout} form={form}>
                                <Form.Item name="physician_notes" label={null}>

                                    <div className="physician_notes-header" >
                                        <span >{t('Physician Notes')}</span>
                                        <Button
                                            type="primary"
                                            size="small"
                                            onClick={() => setVisible(true)}
                                        >
                                            {t('View AI Physician Note')} <AimOutlined />
                                        </Button>
                                    </div>

                                    {/* TextArea below */}
                                    <TextArea readOnly={true} rows={6}></TextArea>
                                </Form.Item>

                                <Modal
                                    destroyOnClose
                                    visible={visible}
                                    footer={null}
                                    onCancel={() => setVisible(false)}
                                    width="80%"
                                    style={{ top: 20 }}
                                    maskClosable={false}
                                >
                                    <MedicalReports
                                        billId={urlParams.opb_id}
                                        opNumber={urlParams.opno}
                                        generateAiReportModal
                                        reference_number={guest?.op_number || urlParams.opno}
                                        templateCode={templateCode}
                                        guestData={guest}
                                        isShowVisitInfo={false}
                                        props={props}
                                        aiReportEditDisable={aiReportEditDisable}
                                    />
                                </Modal>
                            </Form>
                        </div>
                        <div className="left-page-section">
                           
                            {!loading ? (
                                <div class="summary-section">
                                    <span class="summary-title"> {t('SUMMARY')}</span>
                                    <div class="summary-line"></div>
                                </div>
                            ) : (
                                <Skeleton active />
                            )}
                            <div className="radiology-result-section">
                                {!loading ? (
                                    <RadiologyResult
                                        radiologyResponse={response.radiology_result}
                                        {...props}
                                        onFieldChange={(record, fieldName) => handleStatusChange(record, fieldName, 'rad')}
                                    ></RadiologyResult>
                                ) : null}
                            </div>
                            <div className="lab-result-section">
                                {!loading ? (
                                    <DoctorNotesLabResult
                                        {...props}
                                        mode={props.mode}
                                        initialValues={response}
                                        bill_id={referenceId}
                                        onFieldChange={(record, fieldName) => handleStatusChange(record, fieldName, 'lab')}

                                    />
                                ) : null}
                            </div>
                            {/* <div className="questionaire-section card card-header"> */}
                            {/* <div className='questionaire-section'> */}
                                <Card className='question-aire-part'>
                                    <div className="questionaire-section" >
                                {/* <div> */}
                                    {/* //style={{ whiteSpace: 'nowrap' }} */}
                                <span> {t('Review and verify Follow Up.')}</span>
                                {/* </div> */}
                                <div className='question-aire'>
                                    {!loading ? (
                                        <Questionaire
                                            reference_id={referenceId}
                                            mode={props.mode}
                                            questionaireCategory={props.questionaireCategory}
                                            questionaireMode={props.questionaireMode}
                                            followup={props.followup}
                                            isEditable={props.isEditable}
                                            callback={(values) => {
                                                setData((prevState) => {
                                                    // Merge previous state with the new values if necessary
                                                    return { ...prevState, questionaire: { ...prevState.questionaire, ...values } };
                                                });
                                            }}
                                        ></Questionaire>
                                    ) : null}
                                </div>
                                </div>
                                </Card>

                                {/* </div> */}
                            {/* </div> */}
                            <div className="form-content">
                                {!loading ? (
                                    <Form {...formItemLayout} form={form} onFinish={submitFollowUpEntry}>
                                         {/* gutter={[10, 5]} */}
                                        <Row gutter={5}>
                                            <Col xs={24} md={6} xl={6}>
                                                <Form.Item
                                                    name="followup_status"
                                                    label={t('FOLLOW UP STATUS')}
                                                    rules={[{ required: true, message: t('Please Select Followup Status') }]}
                                                >
                                                    {status && status.length ? (
                                                        <Select>
                                                            {status.map((option) => (
                                                                <Option value={option.code}>{option.description}</Option>
                                                            ))}
                                                        </Select>
                                                    ) : null}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={6} md={4} xl={4}>
                                                <Form.Item name="next_follow_date" label={t('NEXT FOLLOW UP')}>
                                                    <DatePicker format="DD/MM/YYYY" disabledDates={disabledDate}></DatePicker>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12} xl={12}>
                                                <Form.Item
                                                    name="follow_up_remarks"
                                                    label={t('REMARKS')}
                                                    rules={[
                                                        {
                                                            max: 250,
                                                            message: t('Length cannot exceed 250 characters!'),
                                                        },
                                                    ]}
                                                >
                                                    {/* <Input/Input> */}
                                                    <TextArea></TextArea>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={20}>
                                            <Col>
                                                <Form.Item>
                                                    <Button type="primary" htmlType="submit" loading={btnLoading}>
                                                        {t('SAVE')}
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                            {/* <Col>
                                                <Form.Item>
                                                    <Button> {t('CANCEL')}</Button>
                                                </Form.Item>
                                            </Col> */}
                                        </Row>
                                    </Form>
                                ) : null}
                            </div>
                        </div>

                        {/* )} */}
                        {/** left-page-section End */}
                    </div>
                </>
                {/* )} */}
            </div>
            </Card>
        </div>
     
    );
}
